import * as _ from 'lodash-es';

export const SearchResultStateMap = {
    scmcommit: 'home.project.summary.scm.commit',
    scm: 'home.project.summary.scm.file',
    trackeritem: 'home.trackeritem',
    project: 'home.project.summary',
    user: 'home.user.userhome',
    docman: 'home.project.summary.docman',
    docmanfolder: 'home.project.summary.docman',
    wiki: 'home.project.summary.wiki.page'
};

export function getSearchResultState(result?) {
    var key = _.get(result, 'section', '');
    return _.get(SearchResultStateMap, key, '');
};

export function getSearchResultParams(result?) {
    if (! result) {
        return null;
    }

    var section = _.get(result, 'section', '');

    switch (section) {
        case 'scmcommit':
            return { unixName: result.project, commithash: result.refId };

        case 'trackeritem':
            return { unixName: result.project, id: result.refId };

        case 'project':
            return { unixName: result.project };

        case 'user':
            return { unixName: result.refId };

        case 'wiki':
            return { unixName: result.project, pagename: result.title };

        case 'scm':
            return { unixName: result.project, path: result.title.substr(1).split('/').join('/'), branch: result.description, view: 'raw' };

        case 'docman':
        case 'docmanfolder':
            return { unixName: result.project, folder: result.refId };

        default:
            return { unixName: result.project };
    };
};

export function getSearchResultUrl(result, stateService, highlight?) {

    var stateName = getSearchResultState(result);
    var stateParams = getSearchResultParams(result);

    if (highlight) {
        stateParams['highlight'] = highlight;
    }

    if (stateName) {
        return stateService.href(stateName, stateParams);
    }
}